import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {StringNode} from "#template/nodes/string/string-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {ExternalId, TemplateLikeNode} from "#template/nodes/types"
import {externalId} from "#template/nodes/validation"
import {templateLike} from "#template/nodes/template-graph/fundamental"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"

export type StringResolveParameters = {
    name: string
    template: TemplateLikeNode
    nodeId: ExternalId
}

const stringResolveDefinition: TemplateNodeDefinition<StringResolveParameters> = {
    nodeClass: "StringResolve",
    validation: {
        parameters: z.object({
            name: z.string(),
            template: templateLike,
            nodeId: externalId,
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class StringResolve extends StringNode<StringResolveParameters> {
    public override get definition() {
        return stringResolveDefinition
    }

    public override evaluate(_scope: GraphBuilderScope, _evaluator: NodeEvaluator): BuilderInlet<string | null> {
        return this.parameters.nodeId
    }
}
